/* eslint-disable react/prop-types */
/* eslint-disable indent-legacy */
/* eslint-disable func-style */
"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import { StatSignup } from "./StatSignup";
import { StatProspect } from "./StatProspect";
import { StatWaiting } from "./StatWaiting";
import * as _utils from "./utils";
import _styles from "./LeadTablerow.module.css";
import { FACILITY_STATUS } from "../common/const";
import moment from "moment";


const _interactionsData = JSON.parse(
  '{"events":{"e-891":{"id":"e-891","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-892"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"6d358be4-a92e-ba20-25c5-479837a1dc0c","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"6d358be4-a92e-ba20-25c5-479837a1dc0c","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721205450829},"e-892":{"id":"e-892","name":"","animationType":"preset","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-33","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-891"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"6d358be4-a92e-ba20-25c5-479837a1dc0c","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"6d358be4-a92e-ba20-25c5-479837a1dc0c","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721205450829}},"actionLists":{"a-32":{"id":"a-32","title":"contact info [show]","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".leadinfo_section","selectorGuids":["ec089049-5221-df34-2029-a531d6682be0"]},"value":"flex"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701793989695},"a-33":{"id":"a-33","title":"contact info [hide]","actionItemGroups":[{"actionItems":[{"id":"a-33-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".leadinfo_section","selectorGuids":["ec089049-5221-df34-2029-a531d6682be0"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701794010668}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function LeadTablerow({
  as: _Component = _Builtin.Block,
  lead = {},
  setActiveTab = () => { },
  onRowClick = () => { },
  handleLeadsRowClick = () => { },
  // name = "Albert Flores",
  // position = "Director",
  // organization = "ABC Organization",
  // website = "https://abc.org/",
  // address = "5400 Phoenix Ave NE Suite 105",
  // city = "ABQ",
  // contact = "5052654777",
}) {
  _interactions.useInteractions(_interactionsData, _styles);

  const isAddressExist = lead.address && lead.address.length !== 0;
  const primaryAddressObj = isAddressExist ? lead.address.find((address) => address.primary === true) || {} : {};
  const primaryAddress = isAddressExist ? Object.entries(primaryAddressObj).map(([key, value]) =>
    key !== 'primary' ? value : ''
  ).join(' ') : "N/A";
  const primaryNumberObj = lead.phoneNumbers && lead.phoneNumbers.length !== 0 ? lead.phoneNumbers.find((phone) => phone.primary === true) : "";

  const parseStatus = (status) => {
    let retval = (
      <div className={"status_tag tag-white"}>
        <div>{FACILITY_STATUS.OPEN.value}</div>
      </div>
    );
    if (status) {
      Object.keys(FACILITY_STATUS).forEach((key) => {
        switch (key) {
          case "CALLED":
            if (parseInt(status.type) === FACILITY_STATUS.CALLED.key) {
              retval = <StatProspect text={FACILITY_STATUS.CALLED.value} />;
            }
            break;
          case "CALLEDSENDINFO":
            if (parseInt(status.type) === FACILITY_STATUS.CALLEDSENDINFO.key) {
              retval = <StatSignup text={FACILITY_STATUS.CALLEDSENDINFO.value} />;
            }
            break;
          case "COLDLEADS":
            if (parseInt(status.type) === FACILITY_STATUS.COLDLEADS.key) {
              retval = <StatWaiting text={FACILITY_STATUS.COLDLEADS.value} />;
            }
            break;
          case "FOLLOWUP":
            if (parseInt(status.type) === FACILITY_STATUS.FOLLOWUP.key) {
              retval = (
                <div className={"status_tag tag-orage"}>
                  <div>{FACILITY_STATUS.FOLLOWUP.value}</div>
                </div>
              );
            }
            break;
          case "CLOSED":
            if (parseInt(status.type) === FACILITY_STATUS.CLOSED.key) {
              retval = (
                <div className={"status_tag tag-red"}>
                  <div>{FACILITY_STATUS.CLOSED.value}</div>
                </div>
              );
            }
            break;
          case "OPEN":
          default:
            break;
        }
      });
    }
    return Array.isArray(status) ? <>{moment().format("MM/DD/YYYY HH:mm")} - {retval}</> : <>{moment(status?.date).format("MM/DD/YYYY HH:mm")} - {retval}</>;
  };

  const facilityName = lead.organization || "N/A";
  const facilityAddress = primaryAddress;
  const facilityPhone = lead.facilityPhone || "N/A";
  const facilityNumber = primaryNumberObj ? primaryNumberObj.number : "N/A";
  const facilityType = lead.facilityType;
  const status = parseStatus(lead.status);
  const county = lead.county;
  const zipcode = lead.zipcode;
  const facilityCapacity = lead.facilityCapacity;
  const facilityContactPerson = lead.name;
  const licenseeName = lead.licenseName;
  const licenseStatus = lead.licenseStatus;
  const licenseDate = lead.licenseDate;
  const dateClosed = lead.dateClosed;
  const updatedBy = lead.updatedBy;
  const updatedAt = lead.updatedAt;
  const createdAt = lead.createdAt;
  const country = primaryAddressObj ? primaryAddressObj.country : "N/A";
  const website = lead.website || "N/A";

  return (
    <_Component
      className={_utils.cx(_styles, "tablerow")}
      // data-w-id="6d358be4-a92e-ba20-25c5-479837a1dc0c"
      tag="div"
      onClick={handleLeadsRowClick}
    >
      <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-auto")}
        tag="div"
      >
        <_Builtin.FormCheckboxWrapper
          className={_utils.cx(_styles, "checkbox-field")}
        >
          <_Builtin.FormCheckboxInput
            className={_utils.cx(_styles, "checkbox")}
            type="checkbox"
            name="checkbox-2"
            data-name="Checkbox 2"
            required={false}
            checked={false}
            id="checkbox-2"
            form={{
              type: "checkbox-input",
              name: "Checkbox 2",
            }}
            inputType="custom"
            customClassName="w-checkbox-input--inputType-custom"
          />
          <_Builtin.FormInlineLabel
            className={_utils.cx(_styles, "checkbox-label")}
          >
            {"Checkbox"}
          </_Builtin.FormInlineLabel>
        </_Builtin.FormCheckboxWrapper>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-5p5")}
        tag="div"
      >
        <_Builtin.Block tag="div">
          <_Builtin.Block tag="div">{facilityName}</_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "text-position")}
            tag="div"
          >
            {facilityAddress}
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-5p5")}
        tag="div"
      >
        <_Builtin.Block tag="div">{facilityPhone}</_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-5p5")}
        tag="div"
      >
        <_Builtin.Link
          className={_utils.cx(_styles, "tablelinkblock")}
          button={false}
          block="inline"
          options={{
            href: "#",
          }}
        >
          <_Builtin.Block tag="div">{facilityNumber}</_Builtin.Block>
        </_Builtin.Link>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-5p5")}
        tag="div"
      >
        <_Builtin.Block tag="div">{facilityType}</_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-6p5")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "status-tag-contain")}
          tag="div"
        >
          {status}
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-5p5")}
        tag="div"
      >
        <_Builtin.Block tag="div">{county}</_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-5p5")}
        tag="div"
      >
        <_Builtin.Block tag="div">{country}</_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-5p5")}
        tag="div"
      >
        <_Builtin.Block tag="div">{website}</_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-5p5")}
        tag="div"
      >
        <_Builtin.Block tag="div">{zipcode}</_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-5p5")}
        tag="div"
      >
        <_Builtin.Block tag="div">{facilityCapacity}</_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-5p5")}
        tag="div"
      >
        <_Builtin.Block tag="div">{facilityContactPerson}</_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-5p5")}
        tag="div"
      >
        <_Builtin.Block tag="div">{licenseeName}</_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-5p5")}
        tag="div"
      >
        <_Builtin.Block tag="div">{licenseStatus}</_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-5p5")}
        tag="div"
      >
        <_Builtin.Block tag="div">{licenseDate}</_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-5p5")}
        tag="div"
      >
        <_Builtin.Block tag="div">{dateClosed}</_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-5p5")}
        tag="div"
      >
        <_Builtin.Block tag="div">
          {`Systemat ${moment(updatedAt).format("MM/DD/YYYY HH:mm")}`
          }</_Builtin.Block>
      </_Builtin.Block>
      {/* <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-5p5")}
        tag="div"
      >
        <_Builtin.Block tag="div">{contact}</_Builtin.Block>
      </_Builtin.Block> */}
      <_Builtin.Block
        className={_utils.cx(_styles, "tablecell", "_w-5p5")}
        tag="div"
      >
        <_Builtin.Link
          className={_utils.cx(_styles, "table_navicon")}
          button={false}
          block="inline"
          options={{
            href: "#",
          }}
          onClick={() => setActiveTab({ isCalling: false, value: "inbox", data: lead })}
        >
          <_Builtin.Image
            className={_utils.cx(_styles, "image-100")}
            width="auto"
            height="auto"
            loading="lazy"
            alt=""
            src="https://cdn.prod.website-files.com/671a44870449e1e437deb039/671a44870449e1e437deb0bb_leads_01.svg"
          />
        </_Builtin.Link>
        <_Builtin.Link
          className={_utils.cx(_styles, "table_navicon")}
          button={false}
          block="inline"
          options={{
            href: "#",
          }}
          onClick={() => setActiveTab({ isCalling: true, value: "inbox", data: lead })}
        >
          <_Builtin.Image
            className={_utils.cx(_styles, "image-100")}
            width="auto"
            height="auto"
            loading="lazy"
            alt=""
            src="/img/telephone-outbound.svg"
          />
        </_Builtin.Link>
      </_Builtin.Block>
    </_Component >
  );
}
